export default function Footer() {
  return (
    <footer className="px-4 py-6 text-center text-sm text-gray-400">
      <div className="flex items-center justify-center gap-2 mb-4">
        <span>Bookings:</span>
        <a href="mailto:bookings@muzink.nl" className="text-gray-400 hover:text-white underline transition-colors">
        bookings@muzink.nl
        </a>
      </div>
      <div className="flex items-center justify-center gap-2 mb-4">
        <span>Demos:</span>
        <a href="mailto:lieke@barankamusic.nl" className="text-gray-400 hover:text-white underline transition-colors">
          lieke@barankamusic.nl
        </a>
      </div>
      <div className="mt-2">© {new Date().getFullYear()} Fresku</div>
    </footer>
  );
} 